import { OutlinedField } from '../../components/Forms'
import React from 'react'

const TitleField = ({ classes, handleChange, value }) => {
  return (
    <OutlinedField
      label="Title"
      className={classes.textField}
      value={value}
      onChange={handleChange('title')}
      required
    />
  )
}

export default TitleField
